import React from 'react';
import AugmentHelpDescription from './AugmentHelpDescription';

/**
 * Shared list body for match / round / clash help popovers.
 * Expects entries from getMatchAugmentsForHelp / getRoundAugmentsForHelp / getClashAugmentsForHelp.
 */
function AugmentHelpItems({ augments, prepend = null }) {
  return (
    <>
      {prepend}
      {augments.map((a) => {
        const tp = a.tacticalPointsCost;
        const showTp = typeof tp === 'number';
        return (
          <div key={a.value} className="augment-help-popover__item">
            <img src={a.svg} alt="" className="augment-help-popover__icon" />
            <div>
              <span className="augment-help-popover__name">
                {a.displayName}
                {showTp ? (
                  <span className="augment-help-popover__tactical-pts" aria-label={`${tp} tactical points`}>
                    {tp} TP
                  </span>
                ) : null}
              </span>
              <AugmentHelpDescription tagline={a.shortDesc} desc={a.desc} />
            </div>
          </div>
        );
      })}
    </>
  );
}

export default AugmentHelpItems;
